<template>
    <div class="footerArea " v-show="showFooter">
        <div class="footerPart box">
            <div class="infoBox item">
                <h1>聚优福利</h1>
                <p class="juyouInfo">聚优福利成立于2014年，隶属于北京影化科技有限公司，作为企业福利生态的建设者，致力于通过福利供应链中的不同 系统，为企业构建专属的员工福利。其秉承以服务为核心，技术为先导的理念，利用智慧化的科技手段提升员工对企业的认可，使福利有效的落地，激发员工的内驱力。让员工、雇主及合作伙伴体验优质的福利服务，为企业解决核心问题，提升企业员工的幸福感。
                </p>
            </div>
            <div class="juyouConnectArea">
                <h2 class="font16">友情链接</h2>
                <p><a href="http://www.juyoufuli.com/entrance/about-us.html">关于聚优</a>
                <a href="http://www.juyoufuli.com/entrance/call-us.html">联系我们</a></p>
                <p><i class="font16">客服热线</i>（9：00 - 21：00）</p>
                <div class="phoneNumBox"><i class="contentPhone"></i>400-010-0689</div>
            </div>
            <img class="juyouScanCode" src="../../assets/images/juyouCode.png" alt="聚优福利">
        </div>
    </div>
</template>

<script>
    import cookie from 'js-cookie';
    export default {
        props:[
            'showFooter'
        ],
        data() {
            return {
                config: global.config,
                userChannel: cookie.get('channel')
            }
        },
        created(){
            
        },
        methods:{
            returnHome(){
                if(this.userChannel == 1){
                    window.location.href ='http://www.life.neigou.com'
                }else{
                    this.$router.push('/')
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.font16{
    font-size: 16px;
    color: #ffffff;
}
.footerPart{
    width: 1200px;
    margin: 0 auto;
}
.footerArea{
    background: #333;
    border-top: 4px solid #c6483a;
    color: #898989;
    font-size: 14px;
    .phoneNumBox{
        font-style:italic;
        font-size: 24px;
        color: #ffffff;
        position: relative;
        padding-left: 30px;
    }
    .juyouConnectArea{
        font-size: 14px;
        h2{
            
            margin: 40px 0 22px 0;
        }
        p{
            margin-bottom: 16px;
        }
        a{
            font-size: 14px;
            color: #898989;
            margin-right: 10px;
        }
    }
    .contentPhone{
        position: absolute;
        left: 0;
        height: 32px;
        width: 24px;
        display: inline-block;
        background: url('../../assets/images/footerPhone.png') no-repeat center;
        background-size: 100%;
    }
    .infoBox{
        margin-top: 40px;
        margin-bottom: 24px;
        h1{
            font-size: 18px;
            color: #ffffff;
            font-weight: bolder;
            margin-bottom: 20px;
        }
    }
    .juyouScanCode{
        height: 90px;
        width: 90px;
        margin-top: 40px;
    }
    .juyouInfo{
        line-height: 26px;
    }
    .juyouConnectArea{
        margin: 0 50px;
        width: 250px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/shares/centerFooter.vue